<<template>
  <one-column-layout :loading="!loaded">
    <case-header title="PNSS Form"  slot="titleBar"
                            class="border-bottom" @close="close"
                            :patient="selectedPatient.info"
                            :patientcase="caseFormState"
    />

    <two-column-layout class="m-sidebar full-width"
                       :sidebar-styles="[isActiveSidebarState(1) ? 'right-shadow' : 'show-overflow']">

      <one-column-layout :content-styles="['full-width']" slot="sidebar" v-show="willShowNavbar">
        <title-bar title="Add/Edit Information" class="space-l" type="sub" slot="titleBar"/>
        <smd-navigation type="editor"
                        :items="navigationItems"
                        :item-validation-flags="sectionValidationFlags"
                        @selected="scrollToSection"/>
      </one-column-layout>

      <smd-full-checkbox-list class="pseudo-dialog"
                              v-if="willShowCheckboxList"
                              slot="sidebar"
                              idField="id"
                              nameField="name"
                              nested-arr-field="conditions"
                              category-field="categoryId"
                              item-field="conditionId"
                              ref="checkboxList"
                              :has-back="true"
                              :ref-list="checkBoxListRefList"
                              :selected-list-getter="checkBoxListGetter"
                              :selected-list-action="checkBoxListAction"
                              :before-list-action="checkBoxBeforeListAction"
                              :title="checkBoxListTitle"
                              @back="hideCheckBoxList" />

      <one-column-layout ref="page_scroll" class="space-l form" slot="content">
        <title-bar :title="'Case # ' + caseNum"
                   :class="'persistent dark'"
                   type="sub--left" slot="subtitleBar">

          <smd-btn v-if="!caseFormState.isClose && !isNewForm && !caseFormState.isArchived" @click="archiveCase" class="smd-icon-action-delete" title="Archive Case"></smd-btn>
          <smd-btn v-if="!caseFormState.isClose && !isNewForm && caseFormState.isArchived" @click="unarchiveCase" class="smd-icon-action-add-record" title="Unarchive Case"></smd-btn>
          <div class="smd-spacer" v-if="hidePrc"></div>
          <smd-btn v-if="!caseFormState.isClose" @click="doSave">Save</smd-btn>
          <smd-btn v-if="!caseFormState.isClose && !isNewForm && !caseFormState.isArchived" @click="closePatientCase">Close</smd-btn>
          <smd-btn v-if="caseFormState.isClose && !isNewForm" @click="openPatientCase">Reopen</smd-btn>
        </title-bar>

        <div class="pogs-list--panels-o">

          <admission class="pogs-list__item"
                     :birthdate="patientBirthdate"
                     :id="$options.admissionSectionID" />

          <ob-score ref="obsection"
                    class="pogs-list__item"
                    :class="isActiveSidebarState(3)"
                    :id="$options.obScoreSectionID"
                    :obstetric-history="obstetricHistory"
                    @add="addObstetricHistory"
                    @search-change="onSearchUpdate"/>

          <!-- Remove Medical History Section
          <medical-history class="pogs-list__item"
                           :class="isActiveSidebarState(2)"
                           :id="$options.medicalHistorySectionID"
                           :medicalHistory="medicalHistory"
                           @add="addMedicalHistory"
                           @search-change="onSearchUpdate"/>
          --->

          <pregnancy-delivery class="pogs-list__item" v-if="isDeliveredNotPostpartum"
                              :id="$options.pregnancyDeliverySectionID" />

          <pregnancy-postpartum-delivery class="pogs-list__item" v-if="isDeliveredPostpartum"
                              :id="$options.pregnancyDeliverySectionID" />

          <PregnancyMorbidities class="pogs-list__item" v-if="isComplicatedPregnancy"
                                :class="isActiveSidebarState(6)"
                                :id="$options.comorbidID"
                                :morbidities="morbidities"
                                @add="addPregnancyComorbidity"
                                @search-change="onSearchUpdate"/>

          <gyne class="pogs-list__item" :id="$options.gyneSectionID" v-if="isGyne"
                :class="isActiveSidebarState(5) || isActiveSidebarState(7)"
                @add="addGyne"
                @addComorbidity="addGyneComorbidity"
                @search-change="onSearchUpdate"/>

          <procedures class="pogs-list__item" :id="$options.proceduresID" v-if="isGyne"
                      :class="isActiveSidebarState(4)"
                      @add="addConcomittant"
                      @search-change="onSearchUpdate"/>

          <OBProcedures class="pogs-list__item" :id="$options.obProceduresID" v-if="isOBCase"
                      :class="isActiveSidebarState(8)"
                      @add="addOBProcedures"
                      @search-change="onSearchUpdate"/>
          <migsInformation class="pogs-list__item" id="CaseFormMIGSInfoSection"/>

          <discharge class="pogs-list__item" id="CaseFormDischargeSection" />
        </div>
      </one-column-layout>

    </two-column-layout>
  </one-column-layout>
</template>

<script>
  import filter from 'lodash/filter'

  import Admission from '../cases/pogs-form__item--admission'
  import OBProcedures from './pogs-form__item--obprocedure'
  import Procedures from './pogs-form__item--procedure'
  import MigsInformation from './pogs-form__item--migs-information.vue'

  import Discharge from './pogs-form__item--discharge'
  import Gyne from './pogs-form__item--gyne'
  import MedicalHistory from '../cases/pogs-form__item--medical-history'
  import PregnancyMorbidities from "./pogs-form__item--pregnancy-morbidities";
  import ObScore from '../cases/pogs-form__item--obscore'
  import CaseHeader from './case-header'
  import PregnancyDelivery from './pogs-form__item--pregnancy'
  import PregnancyPostpartumDelivery from './pogs-form__item--pregnancy-postpartum'
  import Routes from '../../../router/route-constants'

  import scrollListner from '../../../mixins/scroll-listener'
  import scrollNavigation from '../../../mixins/scroll-navigation'
  import uiHelper from '../../../mixins/uihelper'
  import CaseValidation from '../../../mixins/case-validation-mixin'
  import WithErrorValidation from '../../../mixins/with-error-validation-mixin'

  import MaternalFormNav from '../../../reference/case/maternal-form-sections'
  import MaternalRoutes  from '../../../reference/case/maternal-form-constants'

  //medical history
  import {mapGetters, mapActions} from 'vuex'
  import {
    ACTION_SAVE_CASE_FORM,
    ACTION_ADD_CASE_FORM,
    ACTION_REOPEN_PATIENT_CASE,
    ACTION_ARCHIVE_PATIENT_CASE
  } from '../../../store/modules/patients'
  import {FORM_SECTIONS_VALIDATION_STATE} from '../../../store/modules/active-form-section-validations'
  import {
    REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY,
    REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY,
    REF_MATERNAL_FETAL_FORM_ORGAN,
    REF_MATERNAL_FETAL_FORM_GYNE,
    REF_MATERNAL_FETAL_FORM_MORBIDITIES,
    getMapFn, REF_MATERNAL_FETAL_FORM_OBORGAN,
    REF_MALIGNANT_CATEGORY_ID,
    REF_IN_SITU_CONDITION_ID
  } from "../../../store/modules/referencedata2";
  import {
    GETTER_CASE_FORM_STATE,
    MUTATION_CLEAR_CASE_FORM_STATE_FIELDS,
    GETTER_MEDICAL_HISTORY,
    ACTION_UPDATE_MEDICAL_HISTORY,
    GETTER_OBSTETRIC_HISTORY,
    ACTION_UPDATE_OBSTETRIC_HISTORY,
    GETTER_MORBIDITY,
    ACTION_UPDATE_MORBIDITY,
    GETTER_GYNE_MORBIDITY,
    ACTION_UPDATE_GYNE_MORBIDITY,
    GETTER_GYNE_DIAGNOSIS,
    ACTION_UPDATE_GYNE_DIAGNOSIS,
    GETTER_CONCOMITTANT,
    ACTION_UPDATE_CONCOMITTANT,
    GETTER_OBPROCEDURE,
    ACTION_UPDATE_OBPROCEDURE,
    ACTION_CREATE_NEW_CASE_FORM,
    ACTION_EDIT_CASE_FORM,
    GETTER_CASE_FORM_STATE_FIELD,
    SETTER_CASE_FORM_STATE_FIELD,
  } from '../../../store/forms/case-form-state'

  import {
    ACTION_LOAD_PATIENT_INFO,
    GETTER_SELECTED_PATIENT,
    ACTION_CLOSE_PATIENT_CASE
  } from "../../../store/modules/patients";
  import {createHelpers} from 'vuex-map-fields'
  import {reduceModelFromKeys} from "../../../utilities/reduceFunctions";


  const {mapFields} = createHelpers({
    getterType: GETTER_CASE_FORM_STATE_FIELD,
    mutationType: SETTER_CASE_FORM_STATE_FIELD
  });

  const NAVBAR = 1;
  const MEDICALHISTORY = 2;
  const OBSTETRICHISTORY = 3;
  const CONCOMITTANT = 4;
  const GYNE = 5;
  const PREGNANCY_COMORBIDITIES = 6;
  const GYNE_COMORBIDITIES = 7;
  const OBPROCEDURES = 8;

  const NAVIGATION_ITEMS = MaternalFormNav;

  export default{
    name: 'pogs-form-obstetric-case',
    components: {
      MigsInformation,
      CaseHeader,
      PregnancyMorbidities,
      MedicalHistory,
      ObScore,
      Admission,
      PregnancyDelivery,
      PregnancyPostpartumDelivery,
      Gyne,
      Discharge,
      Procedures,
      OBProcedures
    },
    data() {
      return{
        loaded: false,
        sidebarState: NAVBAR
      }
    },
    mixins: [scrollListner, scrollNavigation, uiHelper, CaseValidation, WithErrorValidation],
    computed: {
      ...mapFields([
        'isDelivered',
        'isPostpartum',
        'isPregnancy',
        'isGyne',
        'complicatedPregnancy',
        'caseNum',
        'isClose',
        'concomitantProcedure',
        'gynecologicalDiagnosis',
        'caseFormType'
      ]),
      ...mapGetters({
        selectedPatient  : GETTER_SELECTED_PATIENT,
        caseFormState    : GETTER_CASE_FORM_STATE,
        medicalHistory   : GETTER_MEDICAL_HISTORY,
        morbidities      : GETTER_MORBIDITY,
        gynemorbidities  : GETTER_GYNE_MORBIDITY,
        gynediagnosis    : GETTER_GYNE_DIAGNOSIS,
        obstetricHistory : GETTER_OBSTETRIC_HISTORY,
        sectionValidationFlags: FORM_SECTIONS_VALIDATION_STATE
      }),
      isDeliveredNotPostpartum() {
        return this.isDelivered && !this.isPostpartum
      },
      isDeliveredPostpartum() {
        return this.isDelivered && this.isPostpartum
      },
      isComplicatedPregnancy() {
        return this.isPregnancy && this.complicatedPregnancy;
      },
      isOBCase() {
        return this.caseFormType === 1
      },
      caseId() {
        return this.$route.params.caseid
      },
      patientBirthdate() {
        if (this.selectedPatient.info)
          return this.selectedPatient.info.birthDate;
        else
          return new Date().toDateString()
      },
      checkBoxListAction() {
        switch(this.sidebarState) {
          case MEDICALHISTORY          : return ACTION_UPDATE_MEDICAL_HISTORY;
          case OBSTETRICHISTORY        : return ACTION_UPDATE_OBSTETRIC_HISTORY;
          case CONCOMITTANT            : return ACTION_UPDATE_CONCOMITTANT;
          case OBPROCEDURES            : return ACTION_UPDATE_OBPROCEDURE;
          case GYNE                    : return ACTION_UPDATE_GYNE_DIAGNOSIS;
          case GYNE_COMORBIDITIES      : return ACTION_UPDATE_GYNE_MORBIDITY;
          case PREGNANCY_COMORBIDITIES : return ACTION_UPDATE_MORBIDITY;
          default: return null;
        }
      },
      checkBoxListGetter() {
        switch(this.sidebarState) {
          case MEDICALHISTORY          : return GETTER_MEDICAL_HISTORY;
          case OBSTETRICHISTORY        : return GETTER_OBSTETRIC_HISTORY;
          case CONCOMITTANT            : return GETTER_CONCOMITTANT;
          case OBPROCEDURES            : return GETTER_OBPROCEDURE;
          case GYNE                    : return GETTER_GYNE_DIAGNOSIS;
          case GYNE_COMORBIDITIES      : return GETTER_GYNE_MORBIDITY;
          case PREGNANCY_COMORBIDITIES : return GETTER_MORBIDITY;
          default: return null;
        }
      },
      checkBoxListRefList() {
        switch(this.sidebarState) {
          case MEDICALHISTORY :
            return this.$options.ref_medical_history();
          case OBSTETRICHISTORY :
            return this.$options.ref_obstetric_history();
          case GYNE:
            return this.$options.ref_gyne();
          case GYNE_COMORBIDITIES :
            return this.$options.ref_gyne_comorbidities();
          case PREGNANCY_COMORBIDITIES :
            return this.$options.ref_pregnancy_comorbidities();
          case CONCOMITTANT: {
            return this.$options.ref_procedures();
            //const list = getMapFn(REF_MATERNAL_FETAL_FORM_CONCOMITANT_PROCEDURES)();
            //return [{id:1,name:"Procedures", conditions: list}];
          }
          case OBPROCEDURES: {
            return this.$options.ref_obprocedures();
            //const list = getMapFn(REF_MATERNAL_FETAL_FORM_CONCOMITANT_PROCEDURES)();
            //return [{id:1,name:"Procedures", conditions: list}];
          }
          default: return null;
        }
      },
      checkBoxListTitle() {
        switch(this.sidebarState) {
          case MEDICALHISTORY : return 'Select Medical History';
          case OBSTETRICHISTORY : return 'Select Obstetric History';
          case CONCOMITTANT: return 'Select Procedures';
          case OBPROCEDURES: return 'Select OB Procedures';
          case GYNE: return 'Select Gyne Diagnosis';
          case GYNE_COMORBIDITIES : return 'Select Gyne Co-mobrbidities';
          case PREGNANCY_COMORBIDITIES : return 'Select Pregnancy Co-mobrbidities';
          default: return null;
        }
      },
      isNewForm(){
        return this.$route.name === Routes.ROUTE_NEW_PATIENT_CASE
      },
      navigationItems() {
        return filter(NAVIGATION_ITEMS, (v) => {
          if(v.id === 'pregnancy' && !this.caseFormState.isDelivered) return false;
          return !(v.id === 'gyne' && !this.caseFormState.isGyne);
        });
      },
      willShowCheckboxList() {
        return this.sidebarState !== NAVBAR;
      },
      willShowNavbar() {
        return this.sidebarState === NAVBAR
      },
      hidePrc() {
        return (this.$mq.desktop)
      }
    },
    methods: {
      ...mapActions({
        addCase  : ACTION_ADD_CASE_FORM,
        saveCase : ACTION_SAVE_CASE_FORM,
        closeCase: ACTION_CLOSE_PATIENT_CASE,
        openCase : ACTION_REOPEN_PATIENT_CASE,
        archiveCase: ACTION_ARCHIVE_PATIENT_CASE,
      }),
      doSave() {
        if(this.caseNum){
          this.loaded = false;
          const data = {
            patientid: this.$route.params.patientid,
            caseid: this.$route.params.caseid
          };
          let payload = Object.assign({}, this.caseFormState, data);
          let promise = this.isNewForm ? this.addCase(payload) : this.saveCase(payload);
          promise.then(this.doAfterSave);
        }else{
          this.$toasted.show('Please enter the Case #')
        }
      },
      doAfterSave() {
        this.$router.push({name: Routes.ROOT_ROUTE_CASES})
        //this.$router.go(-1);
      },

      async archiveCase() {
        const data = {
          patientid: this.$route.params.patientid,
          caseid: this.$route.params.caseid
        };
        try {
          await this.$store.dispatch(ACTION_ARCHIVE_PATIENT_CASE, data);
          this.$toasted.show('Case archived successfully');
          this.$router.push({ name: Routes.ROOT_ROUTE_CASES });
        } catch (error) {
          this.$toasted.show('Error archiving case: ' + (error.message || error));
        }
      },
      async unarchiveCase() {
        const data = {
          patientid: this.$route.params.patientid,
          caseid: this.$route.params.caseid
        };

        try {
          await this.$store.dispatch('patients/unarchivePatientCase', data);
          this.$toasted.show('Case unarchived successfully');
          await this.$store.dispatch(ACTION_EDIT_CASE_FORM, data);
        } catch (error) {
          this.$toasted.show('Error unarchiving case: ' + (error.message || error));
        }
      },
      addMedicalHistory(){
        this.scrollToSection(this.$options.medicalHistorySectionID);
        this.sidebarState = MEDICALHISTORY;
        if (this.$refs.checkboxList)
          this.$refs.checkboxList.setSearchTerm("");
      },
      addObstetricHistory(){
        this.scrollToSection(this.$options.obScoreSectionID);
        this.sidebarState = OBSTETRICHISTORY;
        if (this.$refs.checkboxList)
          this.$refs.checkboxList.setSearchTerm("");
      },
      addConcomittant() {
        this.scrollToSection(this.$options.proceduresID);
        this.sidebarState = CONCOMITTANT;
        if (this.$refs.checkboxList)
          this.$refs.checkboxList.setSearchTerm("");
      },
      addOBProcedures() {
        this.scrollToSection(this.$options.obProceduresID);
        this.sidebarState = OBPROCEDURES;
        if (this.$refs.checkboxList)
          this.$refs.checkboxList.setSearchTerm("");
      },
      addPregnancyComorbidity() {
        this.scrollToSection(this.$options.comorbidID);
        this.sidebarState = PREGNANCY_COMORBIDITIES;
        if (this.$refs.checkboxList)
          this.$refs.checkboxList.setSearchTerm("");
      },
      addGyneComorbidity() {
        this.sidebarState = GYNE_COMORBIDITIES;
        if (this.$refs.checkboxList)
          this.$refs.checkboxList.setSearchTerm("");
      },
      addGyne() {
        this.scrollToSection(this.$options.gyneSectionID);
        this.sidebarState = GYNE;
        if (this.$refs.checkboxList)
          this.$refs.checkboxList.setSearchTerm("");
      },
      onSearchUpdate(q) {
        if (q !== "" && this.$refs.checkboxList)
          this.$refs.checkboxList.setSearchTerm(q);
      },
      transformProcedureList(v) {
        const defaultFunc = (elem) => {
          if (elem["categoryId"] === 1) {
            return {procedureType: 1};
          } else if (elem["categoryId"] === 7) {
            return {procedureType: 4};
          } else if (elem["categoryId"] === 8) {
            return {procedureType: 5};
          } else {
            return {procedureType: 1};
          }
        };

        return Object.values(v).reduce(reduceModelFromKeys(defaultFunc)(this.concomitantProcedure),[]);
      },
      transformGyneList(v) {
        const malignantCategories = getMapFn(REF_MALIGNANT_CATEGORY_ID)();
        const inSituConditions = getMapFn(REF_IN_SITU_CONDITION_ID)();
        const defaultFunc = (elem) => {
          const categoryId = elem["categoryId"];
          const conditionId = elem["conditionId"];
          if (inSituConditions.includes(conditionId)) {
            return { gyneStage: 6 };
          } else if (malignantCategories.includes(categoryId)) {
            return {gyneStage: 1};
          } else {
            return {gyneStage: 6};
          }
        };
        return Object.values(v).reduce(reduceModelFromKeys(defaultFunc)(this.gynecologicalDiagnosis),[]);
      },
      checkBoxBeforeListAction(obj) {
        switch(this.sidebarState) {
          case GYNE :
            return this.transformGyneList(obj);
          case CONCOMITTANT :
            return this.transformProcedureList(obj);
          case OBPROCEDURES :
            return this.transformProcedureList(obj);
          default:
            return obj;
        }
      },
      close(){
        this.toggleOverlay();
        this.$router.push({name: Routes.ROOT_ROUTE_CASES});
      },
      hideCheckBoxList(){
        this.sidebarState = NAVBAR;
      },
      isActiveSidebarState(section){
        return this.sidebarState === section ? 'dark active' : undefined;
      },
      scrollToSection(item) {
        this.setScrollToEl(item.sectionID || item);
      },
      openPatientCase() {
        const data = {
          patientid: this.$route.params.patientid,
          caseid: this.$route.params.caseid
        };

        this.doOpenCase(data)
      },
      closePatientCase(){
        const data = {
          patientid: this.$route.params.patientid,
          caseid: this.$route.params.caseid
        };
        let payload = Object.assign({}, this.caseFormState, data);
        this.saveCase(payload)
          .then(result => {

            const validationResult = this.validateCase(this.$options.caseValidationRules, result);
            if (validationResult.length > 0) {
              const tempArray = [];
              validationResult.forEach(item => {
                tempArray.push(item.key)
              });
              this.showCloseCaseDialog(validationResult);
              this.setVueValidations(tempArray);
            } else {
              this.confirmCloseCase(data)
            }
          })
          .catch(err => {
            console.log(err);
            this.$toasted.show('Unable to save case')
          })
      },
      confirmCloseCase(data){
        const close_case  = this.closeCase;
        const toasted     = this.$toasted;
        const doAfterSave = this.doAfterSave;
        this.$dialog.confirm('Are you sure you want to close the case ?', {cancelText: 'Cancel'})
          .then(function () {
            close_case(data).then(() => {
                toasted.show('Patient case has been successfully closed!');
                doAfterSave()
              })
          }).catch()
      },
      doOpenCase(data){
        const open_case  = this.openCase;
        const toasted    = this.$toasted;
        const vuerouter  = this.$router;
        this.$dialog.confirm('Are you sure you want to re-open the case ?', {cancelText: 'Cancel'})
            .then(function () {
              open_case(data).then((result) => {
                if (result.error) {
                  toasted.show(result.error);
                }else {
                  toasted.show('Patient case has been successfully Open!');
                  vuerouter.go();
                }
              })
            }).catch()
      }
    },
    beforeRouteEnter (to, from, next) {
      next( vm => {
        vm.$store.dispatch(ACTION_LOAD_PATIENT_INFO, to.params.patientid).then( result => {
          const patient = result.value;
          if (vm.isNewForm) {
            vm.$store.dispatch(ACTION_CREATE_NEW_CASE_FORM, patient.firstName).then( () => {
              vm.loaded = true;
              vm.initScrollListener()
            })
          } else {
            const params = {
              patientid: to.params.patientid,
              caseid: to.params.caseid
            };
            vm.$store.dispatch(ACTION_EDIT_CASE_FORM, params).then( () => {
              vm.loaded = true;
              vm.initScrollListener();
            })
          }
        });
      })
    },
    mounted() {
      this.setVueValidations([]);
      //this.$store.dispatch(ACTION_LOAD_PATIENT_MEDICAL_HISTORY, {patientId: this.$store.getters[GETTER_SELECTED_PATIENTID]});
    },
    beforeDestroy() {
      this.$store.commit(MUTATION_CLEAR_CASE_FORM_STATE_FIELDS);
    },
    ref_medical_history         : getMapFn(REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY),
    ref_obstetric_history       : getMapFn(REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY),
    ref_procedures              : getMapFn(REF_MATERNAL_FETAL_FORM_ORGAN),
    ref_obprocedures            : getMapFn(REF_MATERNAL_FETAL_FORM_OBORGAN),
    ref_gyne                    : getMapFn(REF_MATERNAL_FETAL_FORM_GYNE),
    ref_pregnancy_comorbidities : getMapFn(REF_MATERNAL_FETAL_FORM_MORBIDITIES),
    ref_gyne_comorbidities      : getMapFn(REF_MATERNAL_FETAL_FORM_MORBIDITIES),
    medicalHistorySectionID     : MaternalRoutes.FORM_SECTION_MED_HIST_ID,
    obScoreSectionID            : MaternalRoutes.FORM_SECTION_OB_SCORE_ID,
    admissionSectionID          : MaternalRoutes.FORM_SECTION_ADMISSION_ID,
    pregnancyDeliverySectionID  : MaternalRoutes.FORM_SECTION_PREG_DELIVERY_ID,
    dischargeSectionID          : MaternalRoutes.FORM_SECTION_DISCHARGE_ID,
    gyneSectionID               : MaternalRoutes.FORM_SECTION_GYNE_ID,
    proceduresID                : MaternalRoutes.FORM_SECTION_PROCEDURES_ID,
    obProceduresID              : MaternalRoutes.FORM_SECTION_OBPROCEDURES_ID,
    comorbidID                  : MaternalRoutes.FORM_SECTION_COMORBID_ID
  }
</script>

<style lang="scss">
.smd-icon-action-delete {
  background: none;
  color: red;
  padding: 0;

  &:hover {
    background: none !important;
    color: red !important;
  }
}

.smd-icon-action-add-record {
  background: none;
  color: green;
  padding: 0;

  &:hover {
    background: none !important;
    color: darkgreen !important;
  }
}

  @media (max-width: 768px) {
    .form__row > *:not(:last-child) {
      margin-right: 0;
    }
    .smd-segment.pill {
      flex-wrap: wrap;
      height: auto !important;

      .smd-segment--item {
        height: 30px;
        margin-bottom: 10px;
      }
    }
    .form .indent {
      margin-left: 0 !important;
    }
  }
  @media (max-width: 455px) {
    .pogs-list--table > [class*='pogs-list__item']:last-child {
      border-top: 1px solid #ececec;
    }
  }
</style>
>